import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

const AppVersionCheck = () => {
  const { logout } = useAuth0();
  const REQUIRED_VERSION = '3.2.0';
  useEffect(() => {
    const storedVersion = localStorage.getItem('app_version');
    if (storedVersion !== REQUIRED_VERSION) {
      localStorage.setItem('app_version', REQUIRED_VERSION);
      logout({ logoutParams: { returnTo: "https://app.facticity.ai" } });
    }
  }, []);

  return null;
};

export default AppVersionCheck;
